import 'jquery';
// Based on included modules in app/assets/stylesheets/admin/_bootstrap.scss and
// app/assets/stylesheets/site/_bootstrap.scss; make sure to keep in sync
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/util';
